;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('CardCompanyAddonsController', CardCompanyAddonsController)

  /* @ngInject */
  function CardCompanyAddonsController ($rootScope, $scope, $q, $window, $translate, ToastService, UdsModalService, BillingService) {
    const getPlanUpgradeConfirmationDialogController = () => $q.when(import('../../dialogs/plan-upgrade-confirmation/plan-upgrade-confirmation-dialog.controller'))

    $scope.flags = {
      loading: true,
      interest: {
        loading: false
      }
    }

    $scope.addons = {
      available: [],
      used: {}
    }

    $scope.companyPlan = null

    const api = {
      getPlanUpgradeConfirmationDialogController,
      _successGetCompanyFeaturesAndAddons,
      _successGetPlanAddons,
      _errorGetPlanAddons,
      _finallyGetPlanAddons,
      _successSendInterestEmail,
      _errorSendInterestEmail,
      _finallySendInterestEmail,
      _openConfirmationDialog,
      _addTitleDescriptionToAddons
    }

    this.getApi = () => api

    activate()

    function activate () {
      $rootScope.getCompanyFeaturesAndAddons()
        .then(api._successGetCompanyFeaturesAndAddons)
    }

    $scope.handleSendInterest = (addonTitle, addonSlug) => {
      $scope.flags.interest.loading = true

      const features = {
        triggerFeature: addonTitle,
        triggerFeatureSlug: addonSlug
      }

      const options = {
        ...features,
        targetPlanName: $scope.companyPlan.name,
        url: $window.location.href
      }

      BillingService.sendInterestEmail(options)
        .then(() => api._successSendInterestEmail(features))
        .catch(api._errorSendInterestEmail)
        .finally(api._finallySendInterestEmail)
    }

    $scope.isContractedAddon = (addonSlug) => {
      return !!$scope.addons.used[addonSlug]
    }

    function _successGetCompanyFeaturesAndAddons (companyPlan) {
      $scope.companyPlan = companyPlan

      $scope.addons.used = {
        ...companyPlan.addons,
        ...companyPlan.features
      }

      BillingService.getPlanAddons(companyPlan.id)
        .then(api._successGetPlanAddons)
        .catch(api._errorGetPlanAddons)
        .finally(api._finallyGetPlanAddons)
    }

    function _successGetPlanAddons (addons) {
      $scope.addons.available = api._addTitleDescriptionToAddons(addons.rows)
    }

    function _errorGetPlanAddons (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    }

    function _finallyGetPlanAddons () {
      $scope.flags.loading = false
    }

    function _successSendInterestEmail (features) {
      api._openConfirmationDialog($scope.companyPlan, features)
    }

    function _errorSendInterestEmail (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    }

    function _finallySendInterestEmail () {
      $scope.flags.interest.loading = false
    }

    function _openConfirmationDialog (companyPlan, features) {
      api.getPlanUpgradeConfirmationDialogController().then(({ PlanUpgradeConfirmationDialogController }) => {
        const planUpgradeConfirmationDialog = UdsModalService.createModal({
          controller: PlanUpgradeConfirmationDialogController,
          modalName: 'planUpgradeConfirmationDialog',
          data: {
            ...features,
            companyPlan
          }
        })

        planUpgradeConfirmationDialog.open()
      })
    }

    function _addTitleDescriptionToAddons (addons) {
      const customAddons = addons.map(addon => {
        if (addon.slug === 'GENERAL.DEFAULT_SSO') {
          addon.title = $translate.instant('generalSettings.plan.addons.titles.defaultSSO')
          addon.description = $translate.instant('generalSettings.plan.addons.descriptions.defaultSSO')
          return addon
        }

        if (addon.slug === 'GENERAL.CUSTOM_SSO') {
          addon.title = $translate.instant('generalSettings.plan.addons.titles.customSSO')
          addon.description = $translate.instant('generalSettings.plan.addons.descriptions.customSSO')
          return addon
        }

        if (addon.slug === 'GENERAL.CUSTOM_LOGIN_URL') {
          addon.title = $translate.instant('generalSettings.plan.addons.titles.customLogin')
          addon.description = $translate.instant('generalSettings.plan.addons.descriptions.customLogin')
          return addon
        }

        if (addon.slug === 'ARTS.USE_TERMS') {
          addon.title = $translate.instant('generalSettings.plan.addons.titles.imageUseTerm')
          addon.description = $translate.instant('generalSettings.plan.addons.descriptions.imageUseTerm')
          return addon
        }

        addon.description = ''

        return addon
      })

      return customAddons
    }
  }
})()
